import React from 'react';

import { t } from '@/utility/localization';
import { CM_PORTAL_GETTING_STARTED_ROUTE } from '@/utility/routesHelper';

import { useAuthContext } from '@/contexts/AuthContext';
import { useCommunityPortalContext } from '@/contexts/CommunityPortalContext';

import NPLButton from '@/components/npl/NPLButton';

import useInviteUsersModal from '@/hooks/useInviteUsersModal';

import InviteMembersModal from './InviteMembersModal';

const InviteMembersBtn = ({
  inviteClickCb,
  hierarchy,
  btnText,
  btnSize,
  rounded,
  multiply
}) => {
  const {
    activeCommunity,
    isWhatsappExperienceCommunity,
    communityAdminCount,
    communityAdminMaxLimit
  } = useCommunityPortalContext();
  const { user } = useAuthContext();
  const activeCommunityId = activeCommunity?._id;

  const {
    open: modalOpen,
    openModal,
    closeModal,
    inputSearch,
    setInputSearch,
    searchResults,
    memberOrAdmin,
    setMemberOrAdmin,
    supportDropdownText,
    addUserToSelectedUsers,
    selectedUsers,
    removeUserFromSelectedUsers,
    popFromSelectedUsers,
    validatedSelectedUsers,
    removeSelectedUserAndSetInputSearch,
    handleSendInvites,
    addUserToSelectedMembers,
    selectedMembers,
    popFromSelectedMembers,
    selectedMemberData,
    removeUserFromSelectedMembers,
    errMsg,
    loading
  } = useInviteUsersModal(activeCommunityId);

  const communityShareLink = activeCommunity?.link;

  const handleInviteBtnClick = () => {
    openModal(true);

    if (inviteClickCb) inviteClickCb();
  };

  return (
    <>
      <NPLButton
        hierarchy={hierarchy ?? 'neutral_primary'}
        size={btnSize ?? 'sm'}
        leadIcon="user-plus-01"
        onClick={handleInviteBtnClick}
        buttonText={btnText ?? t('invite-members')}
        rounded={rounded}
        multiply={multiply}
      />
      {modalOpen && (
        <InviteMembersModal
          fromPage={CM_PORTAL_GETTING_STARTED_ROUTE}
          user={user}
          isWhatsappExperienceCommunity={isWhatsappExperienceCommunity}
          open={modalOpen}
          closeModal={closeModal}
          inputSearch={inputSearch}
          shareLink={communityShareLink}
          onInputChange={(e) => setInputSearch(e.target.value)}
          key={'invite-members-modal'}
          memberOrAdmin={memberOrAdmin}
          setMemberOrAdmin={setMemberOrAdmin}
          searchResults={searchResults}
          supportDropdownText={supportDropdownText}
          addUserToSelectedUsers={addUserToSelectedUsers}
          selectedUsers={selectedUsers}
          removeUserFromSelectedUsers={removeUserFromSelectedUsers}
          popFromSelectedUsers={popFromSelectedUsers}
          validatedSelectedUsers={validatedSelectedUsers}
          removeSelectedUserAndSetInputSearch={
            removeSelectedUserAndSetInputSearch
          }
          handleSendInvites={() => handleSendInvites(activeCommunityId)}
          communityAdminCount={communityAdminCount}
          communityAdminMaxLimit={communityAdminMaxLimit}
          addUserToSelectedMembers={addUserToSelectedMembers}
          selectedMembers={selectedMembers}
          popFromSelectedMembers={popFromSelectedMembers}
          selectedMemberData={selectedMemberData}
          removeUserFromSelectedMembers={removeUserFromSelectedMembers}
          errMsg={errMsg}
          loading={loading}
          activeCommunity={activeCommunity}
        />
      )}
    </>
  );
};

export default InviteMembersBtn;
